import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "prediction-card"
}
const _hoisted_2 = { class: "card--tag color-bright-blue taginfoDv" }
const _hoisted_3 = { class: "StatusInfoDv" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 1,
  class: "infoNegative"
}
const _hoisted_6 = { class: "prediction-card-body" }
const _hoisted_7 = { class: "signalHeader" }
const _hoisted_8 = { class: "firstDv" }
const _hoisted_9 = { class: "textDv" }
const _hoisted_10 = { class: "symbol-with-info" }
const _hoisted_11 = {
  key: 0,
  class: "endDv"
}
const _hoisted_12 = { class: "lastDv" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 0,
  class: "price-target-card"
}
const _hoisted_15 = { class: "price-info" }
const _hoisted_16 = { class: "entry" }
const _hoisted_17 = { class: "label" }
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "date" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = { class: "target" }
const _hoisted_22 = { class: "label" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "date" }
const _hoisted_25 = { class: "progress-container" }
const _hoisted_26 = { class: "progress-bar" }
const _hoisted_27 = { class: "label-content" }
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = {
  key: 0,
  class: "date"
}
const _hoisted_30 = {
  key: 1,
  class: "prediction-card"
}
const _hoisted_31 = { class: "card--tag color-purple taginfoDv" }
const _hoisted_32 = { class: "StatusInfoDv" }
const _hoisted_33 = { class: "PredictionBodyDv" }
const _hoisted_34 = { class: "FirstInfoDv" }
const _hoisted_35 = { class: "textDv" }
const _hoisted_36 = {
  key: 2,
  class: "secondDv"
}
const _hoisted_37 = { class: "SecondInfoDv" }
const _hoisted_38 = { class: "EntryPriceDv" }
const _hoisted_39 = ["innerHTML"]
const _hoisted_40 = { style: {"display":"flex","justify-content":"flex-end","align-items":"center"} }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = { class: "TargetPriceDv" }
const _hoisted_43 = ["innerHTML"]
const _hoisted_44 = ["innerHTML"]
const _hoisted_45 = { class: "PredictionchartDv" }
const _hoisted_46 = { class: "PredictionFooterDv" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_StockImageTag = _resolveComponent("StockImageTag")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.trade)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.showRemove)
            ? (_openBlock(), _createBlock(_component_IconComponent, {
                key: 0,
                class: "iconDv remove-icon c-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onRemove())),
                onTouchstart: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onRemove())),
                id: `minusWining${_ctx.index}`,
                icon: "minus.svg"
              }, null, 8, ["id"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("profileDetails.headings.predictions")), 1),
          _createElementVNode("div", _hoisted_3, [
            (_ctx.predictionType === 'Long')
              ? (_openBlock(), _createElementBlock("h2", _hoisted_4, _toDisplayString(_ctx.$t("profileDetails.labels.Long")), 1))
              : _createCommentVNode("", true),
            (_ctx.predictionType === 'Short')
              ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_ctx.$t("profileDetails.labels.Short")), 1))
              : _createCommentVNode("", true),
            _cache[4] || (_cache[4] = _createElementVNode("h4", null, null, -1)),
            _createElementVNode("h3", null, _toDisplayString(_ctx.trade.isOpen
            ? _ctx.$t("profileDetails.labels.Open")
            : _ctx.$t("profileDetails.labels.Closed")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                (_openBlock(), _createBlock(_component_StockImageTag, {
                  disableRouting: _ctx.disableRouting,
                  stockId: _ctx.trade.stockId,
                  imgUrl: _ctx.trade.logoUrl,
                  symbol: _ctx.trade.symbol,
                  market: _ctx.trade.type || _ctx.trade.market,
                  key: _ctx.trade.stockId
                }, null, 8, ["disableRouting", "stockId", "imgUrl", "symbol", "market"])),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("h2", null, _toDisplayString(_ctx.trade.symbol ?? "-"), 1),
                    _createVNode(_component_el_tooltip, {
                      class: "prediction-info-tooltip",
                      effect: "dark",
                      content: "Prediction made will be realized on day end",
                      placement: "bottom-start",
                      "popper-style": {
                  background: 'var(--base-darkest)',
                  color: 'var(--base-text)',
                  width: '130px',
                  fontSize: '10px',
                  padding: '5px',
                  borderRadius: '4px',
                  border: 'none',
                }
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_IconComponent, {
                          class: "info-icon",
                          icon: "info-circle.svg"
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_el_tooltip, {
                    class: "box-item",
                    effect: "dark",
                    content: _ctx.trade.name ?? '-',
                    placement: "top-start",
                    "popper-style": {
                background: 'var(--base-darkest)',
                color: 'var(--text-color)',
                fontSize: '10px',
                padding: '4px',
                borderRadius: '4px',
                border: 'none',
              }
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(_ctx.trade.name ?? "-"), 1)
                    ]),
                    _: 1
                  }, 8, ["content"])
                ])
              ]),
              (_ctx.stock)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("h2", {
                        class: "whiteDoler",
                        ref: "priceElement",
                        innerHTML: 
                _ctx.$filters.systemNumberConvention(
                  _ctx.stock.price,
                  true,
                  false,
                  _ctx.widthCalculating
                )
              
                      }, null, 8, _hoisted_13),
                      _createElementVNode("div", {
                        class: _normalizeClass([{
                downward: _ctx.stock.changesPercentage < 0,
              }, "informationGridWatchlistViewDv"])
                      }, [
                        _createVNode(_component_el_tooltip, {
                          class: "box-item",
                          effect: "dark",
                          content: '$' + _ctx.stock.change,
                          placement: "top-start"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_IconComponent, {
                                class: "priceIcon",
                                icon: "stock-pricing-up-icon.svg"
                              }),
                              _createTextVNode(" " + _toDisplayString(Math.abs(
                      _ctx.$filters.systemNumberConvention(
                        _ctx.stock.changesPercentage,
                        false
                      )
                    )) + "% ", 1)
                            ])
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ], 2)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.stock)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("profileDetails.labels.EntryPrice")), 1),
                      _createElementVNode("p", {
                        class: "price",
                        innerHTML: 
                _ctx.$filters.systemNumberConvention(
                  _ctx.samePriceAsCurrent ? _ctx.stock?.price : _ctx.trade.price,
                  true,
                  false,
                  300
                )
              
                      }, null, 8, _hoisted_18),
                      _createElementVNode("p", _hoisted_19, _toDisplayString(_ctx.$filters.formatDateTwo(_ctx.trade.tradeDate, "MMM DD, YYYY")), 1)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["change", {
              positive:
                _ctx.$filters.systemAccuracyPercentage(_ctx.entryChange, 100) >= 50,
            }])
                    }, [
                      _createElementVNode("span", {
                        innerHTML: _ctx.$filters.systemAccuracyPercentage(_ctx.entryChange, 100)
                      }, null, 8, _hoisted_20),
                      _cache[5] || (_cache[5] = _createTextVNode("% ", -1))
                    ], 2),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.$t("profileDetails.labels.TargetPrice")), 1),
                      _createElementVNode("p", {
                        class: "price",
                        innerHTML: 
                _ctx.$filters.systemNumberConvention(
                  _ctx.trade.predicition.price,
                  true,
                  false,
                  300
                )
              
                      }, null, 8, _hoisted_23),
                      _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$filters.formatToMonthDay(
                  _ctx.trade.predicition.date,
                  "MMM DD, YYYY"
                )), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", {
                        class: "progress",
                        style: _normalizeStyle({ width: `calc(100% - ${_ctx.PredictionAccuracy}%)` })
                      }, null, 4),
                      _createElementVNode("div", {
                        class: "progress-label",
                        ref: "progressLabelRef",
                        style: _normalizeStyle(_ctx.progressLabelStyle)
                      }, [
                        _createVNode(_component_el_tooltip, {
                          class: "box-item",
                          effect: "dark",
                          content: '$' + _ctx.PredictionCurrentLivePrice,
                          placement: "top-start"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_27, [
                              _createElementVNode("span", {
                                class: "percentage",
                                innerHTML: 
                      _ctx.$filters.systemNumberConvention(
                        _ctx.PredictionAccuracy,
                        false,
                        true,
                        100
                      ) + '%'
                    
                              }, null, 8, _hoisted_28),
                              (_ctx.trade.realizedDate)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_29, "(" + _toDisplayString(_ctx.$filters.formatDateTwo(
                        _ctx.trade.realizedDate,
                        "MMM DD, YYYY"
                      )) + ")", 1))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ], 4)
                    ]),
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "progress-scale" }, [
                      _createElementVNode("span", null, "0%"),
                      _createElementVNode("span", null, "50%"),
                      _createElementVNode("span", null, "100%")
                    ], -1))
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (false && _ctx.trade)
      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
          (_ctx.showRemove)
            ? (_openBlock(), _createBlock(_component_IconComponent, {
                key: 0,
                class: "iconDv c-pointer",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onRemove())),
                onTouchstart: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onRemove())),
                id: `minusWining${_ctx.index}`,
                icon: "minus.svg"
              }, null, 8, ["id"]))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("profileDetails.headings.predictions")), 1),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.predictionType), 1),
            _cache[7] || (_cache[7] = _createElementVNode("h4", null, null, -1)),
            _createElementVNode("h3", null, _toDisplayString(_ctx.trade.isOpen ? "Open" : "Closed"), 1)
          ]),
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              (_openBlock(), _createBlock(_component_StockImageTag, {
                disableRouting: _ctx.disableRouting,
                stockId: _ctx.trade.stockId,
                imgUrl: _ctx.trade.logoUrl,
                symbol: _ctx.trade.symbol,
                market: _ctx.trade.type || _ctx.trade.market,
                key: _ctx.trade.stockId
              }, null, 8, ["disableRouting", "stockId", "imgUrl", "symbol", "market"])),
              _createElementVNode("div", _hoisted_35, [
                (_ctx.isOverflowing)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 0,
                      class: "box-item",
                      effect: "dark",
                      content: _ctx.trade.symbol,
                      placement: "top-start"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("h1", { ref: "tradeSymbol" }, _toDisplayString(_ctx.trade.symbol ?? "-"), 513)
                      ]),
                      _: 1
                    }, 8, ["content"]))
                  : (_openBlock(), _createElementBlock("h1", {
                      key: 1,
                      ref: "tradeSymbol"
                    }, _toDisplayString(_ctx.trade.symbol ?? "-"), 513)),
                (_ctx.stock)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      (_ctx.isSymbolOverflowing)
                        ? (_openBlock(), _createBlock(_component_el_tooltip, {
                            key: 0,
                            class: "box-item",
                            effect: "dark",
                            content: _ctx.stock.name,
                            placement: "top-start"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", {
                                ref: "symbolTitle",
                                class: "symbolTitle"
                              }, _toDisplayString(_ctx.stock.name ?? "-"), 513)
                            ]),
                            _: 1
                          }, 8, ["content"]))
                        : (_openBlock(), _createElementBlock("p", {
                            key: 1,
                            ref: "symbolTitle",
                            class: "symbolTitle"
                          }, _toDisplayString(_ctx.stock.name ?? "-"), 513))
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.$t("profileDetails.labels.Entry")) + ":", 1),
                _createElementVNode("p", {
                  innerHTML: 
              _ctx.$filters.systemNumberConvention(
                _ctx.samePriceAsCurrent ? _ctx.stock?.price : _ctx.trade.price,
                true,
                false,
                _ctx.widthCalculating
              )
            
                }, null, 8, _hoisted_39),
                _createElementVNode("div", _hoisted_40, [
                  _createVNode(_component_IconComponent, {
                    class: _normalizeClass([{ negative: _ctx.entryChange < 0 }, "priceIcon"]),
                    icon: "stock-pricing-up-icon.svg"
                  }, null, 8, ["class"]),
                  _createElementVNode("h3", {
                    innerHTML: 
                _ctx.$filters.systemNumberConvention(_ctx.entryChange, false, true, 100)
              ,
                    class: _normalizeClass({ negative: _ctx.entryChange < 0 })
                  }, null, 10, _hoisted_41),
                  _createElementVNode("h3", {
                    class: _normalizeClass({ negative: _ctx.entryChange < 0 })
                  }, "%", 2)
                ])
              ]),
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("h2", null, _toDisplayString(_ctx.$t("profileDetails.labels.Target")), 1),
                _createElementVNode("p", {
                  innerHTML: 
              _ctx.$filters.systemNumberConvention(
                _ctx.trade.predicition.price,
                true,
                false,
                _ctx.widthCalculating
              )
            
                }, null, 8, _hoisted_43),
                _createElementVNode("div", {
                  style: {"display":"flex","justify-content":"flex-end","align-items":"center"},
                  class: _normalizeClass(["accuracy", {
              low: _ctx.PredictionAccuracy <= 20,
              medium: _ctx.PredictionAccuracy > 20 && _ctx.PredictionAccuracy <= 60,
              high: _ctx.PredictionAccuracy > 60,
            }])
                }, [
                  _createVNode(_component_IconComponent, { icon: "icon-accuracy.svg" }),
                  _createElementVNode("h3", {
                    innerHTML: 
                _ctx.$filters.systemNumberConvention(
                  _ctx.PredictionAccuracy,
                  false,
                  true,
                  100
                ) + '%'
              
                  }, null, 8, _hoisted_44)
                ], 2)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createVNode(_component_apexchart, {
              type: _ctx.chartType,
              height: "100%",
              width: "100%",
              ref: "chart",
              options: _ctx.chartOptions,
              series: _ctx.series
            }, null, 8, ["type", "options", "series"])
          ]),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.$filters.formatDateTwo(_ctx.trade.tradeDate)), 1),
            _createElementVNode("h2", null, "< " + _toDisplayString(_ctx.totalDays) + " D>", 1),
            _createElementVNode("h2", null, _toDisplayString(_ctx.$filters.formatDateTwo(_ctx.trade.predicition.date)), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}